
const digest = 'd1c105ea70e64c49163c0b6a967545106e333a871bfe3a2f0486788a475a08b0';
const classes = {"wrapper":"_wrapper_4m8xk_1","microphoneWrapper":"_microphoneWrapper_4m8xk_9","microphone":"_microphone_4m8xk_9","pulseAnimate":"_pulseAnimate_4m8xk_1","ring1":"_ring1_4m8xk_41","ring2":"_ring2_4m8xk_44","ring3":"_ring3_4m8xk_47"};
const css = `._wrapper_4m8xk_1 {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 40px 0;
}
._wrapper_4m8xk_1 ._microphoneWrapper_4m8xk_9 {
  height: 200px;
  width: 200px;
  position: relative;
}
._wrapper_4m8xk_1 ._microphoneWrapper_4m8xk_9 ._microphone_4m8xk_9 {
  display: flex;
  height: inherit;
  width: inherit;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #eaf2ff 0, #cad9f3 100%);
  box-shadow: -3px 7px 13px 0 rgba(68, 70, 105, 0.15);
  border-radius: 100%;
  position: absolute;
  z-index: 10;
  flex-direction: column;
  gap: 5px;
}
._wrapper_4m8xk_1 ._microphoneWrapper_4m8xk_9 ._microphone_4m8xk_9 img {
  width: 70px;
  height: 70px;
}
._wrapper_4m8xk_1 ._microphoneWrapper_4m8xk_9 span {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #3c3f9c;
  border-radius: 100%;
  opacity: 0.8;
  animation: _pulseAnimate_4m8xk_1 4s ease-out infinite;
}
._wrapper_4m8xk_1 ._microphoneWrapper_4m8xk_9 ._ring1_4m8xk_41 {
  animation-delay: 0s;
}
._wrapper_4m8xk_1 ._microphoneWrapper_4m8xk_9 ._ring2_4m8xk_44 {
  animation-delay: 1s;
}
._wrapper_4m8xk_1 ._microphoneWrapper_4m8xk_9 ._ring3_4m8xk_47 {
  animation-delay: 2s;
}
@keyframes _pulseAnimate_4m8xk_1 {
  100% {
    opacity: 0;
    transform: scale(1.3);
  }
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  